/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Filter_VehiclesInputs */

const fr_map_filter_vehicles = /** @type {(inputs: Map_Filter_VehiclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer les véhicules`)
};

const en_map_filter_vehicles = /** @type {(inputs: Map_Filter_VehiclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter vehicles`)
};

/**
* | output |
* | --- |
* | "Filter vehicles" |
*
* @param {Map_Filter_VehiclesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_filter_vehicles = /** @type {((inputs?: Map_Filter_VehiclesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Filter_VehiclesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_filter_vehicles(inputs)
	return en_map_filter_vehicles(inputs)
});